<template>
  <!--  <a-spin :spinning="isLoading">-->
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cell-db-click="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
<!--        <btn-confirm-->
<!--            title="确定要立即执行选中数据吗?"-->
<!--            :ready="setOpenReady"-->
<!--            @confirm="setOpen"-->
<!--        >-->
<!--          <vxe-button>立即执行</vxe-button>-->
<!--        </btn-confirm>-->
      </template>

      <template v-slot:operate="{row}">
        <vxe-button v-if="row.isStart === 0" style="margin-right: 10px" size="mini" status="primary"
                    @click="setSingleOpen(row)"
        >
          立即启用
        </vxe-button>
      </template>

    </x-grid>


    <!--明细页表单简化通用写法-->
    <formModal title="客户SOP群发" :visible="editModalVisible" :width="1300">
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)"
                  @closed="closeEdit"
      >
      </detailForm>
    </formModal>
  </div>
  <!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase"

import detailForm from "./BulkAssistant";
import {dataApi} from "@/services/operate/BulkAssistant";


//列表接口
const url = api.operate.SOPLIST;

//主键
const rowId = 'sopId';

//列
const columns = [
  // fac.makeColumnRadioDefault(),
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("sopName", "SOP名称", 160),
  fac.makeColumn("userNames", "执行员工"),
  // fac.makeColumn("tagNames", "执行客户", 300),
  fac.makeColumn("tagNames", "标签"),
  fac.makeColumn("isStartName", "执行状态", 160),
  // fac.makeColumn("createDate", "创建时间", 300),
  // fac.makeColumn("lastModifyDate", "最后修改时间", 300),
  fac.makeColumn({
    title: "操作",
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 300,
    fixed: 'right'
  }),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'sopName'},
  {field: 'isStartName'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: true,
  addData: true,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  components: {
    detailForm,
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  async mounted() {
  },
  methods: {
    loadBaseData,
    closeEdit(){
      this.editModalVisible = false
      this.refresh()
    },
    /**
     * ready 需要返回布尔
     */
    setOpenReady() {
      let row = this.getRows();
      if (row.length !== 1) {
        this.$message.error('请选择一条数据');
        return false;
      }
      if (row[0].isUse) {
        this.$message.error('该数据已启用');
        return false;
      }
      return true;
    },
    async setOpen() {
      let row = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      this.loading(true);
      await dataApi.updateIsUse(row[0][this.rowId]).then(() => {
        this.$message.success('立即执行成功');
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh()
    },
    async setSingleOpen(row) {
      console.log(row)
      this.loading(true);
      await dataApi.updateIsUse(row.sopId).then(() => {
        this.$message.success('立即执行成功');
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh()
    }
  }
}
</script>

<style scoped>
</style>
